module.exports = __webpack_public_path__ + "static/media/edit.b3d5d658.svg";